import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../../components/Header/Header';
import SubNav from '../../components/SubNav/SubNav';
import Footer from '../../components/Footer/Footer';
import './Support.css';
import '../../styles/Dashboard.css';
import { Link } from 'react-router-dom';

const Support = () => {
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');
    setSuccess('');

    try {
      const response = await fetch('/api/v1/support/message', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({ subject, message })
      });

      if (!response.ok) {
        throw new Error('Failed to send message');
      }

      setSuccess('Message sent! We\'ll get back to you soon.');
      setSubject('');
      setMessage('');
    } catch (err) {
      setError('Failed to send message. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="dashboard-page">
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>Support | NowTarot AI</title>
      </Helmet>
      <Header />
      <SubNav />
      
      <div className="dashboard-container">
        {error && <div className="alert alert-error">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}

        {/* Quick Help Card */}
        <div className="dash-card">
          <div className="dash-card-header">
            <h3 className="dash-card-title">
              <span className="card-icon">💡</span>
              Quick Help
            </h3>
          </div>
          
          <div className="help-grid">
            <Link to="/account" className="help-item">
              <div className="help-icon">📱</div>
              <div className="help-text">
                <div className="help-label">Change Phone Number</div>
                <div className="help-desc">Go to Settings → Phone → Change</div>
              </div>
              <span className="help-arrow">→</span>
            </Link>
          </div>
        </div>

        {/* Contact Form Card */}
        <div className="dash-card">
          <div className="dash-card-header">
            <h3 className="dash-card-title">
              <span className="card-icon">✉️</span>
              Contact Support
            </h3>
          </div>
          
          <p className="support-intro">
            Can't find what you need? Send us a message and we'll get back to you as soon as possible.
          </p>
          
          <form onSubmit={handleSubmit} className="support-form">
            <div className="form-group">
              <label htmlFor="subject" className="form-label">Subject</label>
              <input
                id="subject"
                type="text"
                className="form-input"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                placeholder="Brief description of your issue"
                required
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="message" className="form-label">Message</label>
              <textarea
                id="message"
                className="form-textarea"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Describe your issue or question in detail..."
                rows="5"
                required
              />
            </div>
            
            <button 
              type="submit" 
              className="btn btn-primary btn-full"
              disabled={isSubmitting || !message.trim() || !subject.trim()}
            >
              {isSubmitting ? 'Sending...' : 'Send Message'}
            </button>
          </form>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default Support;
